import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import AllEvent from './AllEvent'

class ParselAllEvent extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={AllEvent} {...props}/>
   )
 }
}



export default ParselAllEvent;
